import type { Order } from "../Order.js";

export function getItemAmountInOrder(order: Pick<Order, "products" | "vouchers">): number {
	const productAmount = order.products.reduce((acc, product) => acc + product.quantity, 0);
	const voucherAmount = order.vouchers.reduce((acc, voucher) => acc + voucher.quantity, 0);
	return productAmount + voucherAmount;
}
